import { LabsAndFacilitySelect } from '../../LabsAndFacilitySelect';

export const ForMeAndSalesRep = ({ disabled = false }) => {
  return <LabsAndFacilitySelect disabled={disabled} />;
};
